<template>
  <div>
    <h1>Multipagos failed</h1>
  </div>
</template>

<script>
export default {
    name: 'MultipagosFailed'
}
</script>

<style scoped>
    h1 {
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Multipagos/MultipagosFailed.vue